import { Injectable } from '@angular/core';

import { BreadcrumbModel } from './breadcrumb.models';
import { BreadcrumbsResolve } from './breadcrumbs.resolver';

@Injectable({ providedIn: 'root' })
export class EmptyBreadcrumbsResolver extends BreadcrumbsResolve<any> {
    protected customResolve(model: any): BreadcrumbModel[] {
        return [];
    }
}
